module.exports = __webpack_public_path__ + "static/media/central-african-republic.e5bac49e.png";